import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
} from '@mui/material';
import Footer from '../navbar/Footer';

const bulletins = [
  {
    title: "Projections Ages Quinquennaux 2020-2024",
    description: "Données sur les projections démographiques pour la période 2020-2024, présentées par groupes d'âges quinquennaux.",
    link: "/documents/ProjectionGroupeAgeQuins/Projections-âges-quinquénaux-20-mai-14.xlsx",
  }
];

function ProjectionGroupeAgeQuin() {
  const [rapports, setRapports] = React.useState(bulletins.slice(0, 2));

  const handleLoadMore = () => {
    const newRapports = bulletins.slice(rapports.length, rapports.length + 2);
    setRapports([...rapports, ...newRapports]);
  };

  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Projections démographiques par groupes d'âges quinquennaux
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '16px' }}>
          Cette section présente les projections démographiques par groupes d’âges quinquennaux pour le Burundi. 
        </Typography>

        <Grid container spacing={2} style={{ marginTop: '10px' }}>
          {rapports.map((bulletin, index) => (
            <Grid item xs={12} key={index}>
              <Card variant="outlined" style={{ borderRadius: '8px', padding: '16px' }}>
                <CardContent>
                  <Box display="flex" alignItems="flex-start">
                    <Box width="30%" marginRight="16px">
                      <a href={bulletin.link} target="_blank" rel="noopener noreferrer">
                        <img
                          src="/asset/cover/cover.jpg"
                          alt="Couverture"
                          style={{ width: '100%', height: 'auto', display: 'block' }}
                        />
                      </a>
                    </Box>
                    <Box width="70%">
                      <Typography
                        variant="h5"
                        component="div"
                        style={{ fontWeight: 'bold', color: '#388E3C', marginBottom: '8px' }}
                      >
                        <a
                          href={bulletin.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: '#388E3C' }}
                        >
                           {<DownloadIcon />}{bulletin.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {bulletin.description}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {rapports.length < bulletins.length && (
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                size="small"
                variant="contained"
                style={{ backgroundColor: '#388E3C', color: 'white' }}
                onClick={handleLoadMore}
              >
                Plus de rapports
              </Button>
            </Grid>
          )}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default ProjectionGroupeAgeQuin;